import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getQuizzes(_obj, params) {
    const res = await axios.get(`api/lms/quizzes/`, { params });
    return res.data;
  },
  async getQuiz(_obj, id) {
    const res = await axios.get(`api/lms/quizzes/${id}/`);
    return res.data;
  },
  async createQuiz(_obj, data) {
    const res = await axios.post(`api/lms/quizzes/`, data);
    return res.data;
  },
  async updateQuiz(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/quizzes/${id}/`, data);
    return res.data;
  },
  async deleteQuiz(_obj, id) {
    const res = await axios.delete(`api/lms/quizzes/${id}/`);
    return res.data;
  },
  async getQuizUploadUrl(_obj, data) {
    const res = await axios.post(`api/lms/quizzes/upload-url/`, data);
    return res.data;
  },
};

export const quizzes = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
